// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1mEEJ","label":"SetPasswdForm_label__1sI2P"};